/*
  Carrito KARATI: cajón (snippets/cart-drawer.liquid) y página /cart
  (sections/karati-carrito.liquid). Los dos son raíces [data-ks-carrito] y
  comparten cantidades, quitar, nota, factura y CSF; cada cambio redibuja con
  Section Rendering el cajón, la página y el contador del header.
  Abrir, cerrar y redibujar al agregar desde la página siguen siendo del tema
  (cart-drawer en assets/cart.js). Aquí:
  - Cantidad y Quitar con /cart/change.js, redibujando el cajón sin reabrirlo.
  - Barras que se llenan desde 0 al abrir y se deslizan en cada cambio.
  - Resaltado y aviso del producto recién agregado; aviso al quitar.
  - Nota del pedido guardada con /cart/update.js al salir del campo.
  - Sugerencias: recomendaciones complementarias de Shopify del producto más
    reciente, luego lo más comprado y al final la colección de respaldo; nunca
    lo que ya está en el carrito ni lo agotado. Siempre 7.
  - Página: vaciar con confirmación, metas que crecen desde 0 y "Seguir
    comprando" a la última colección visitada.
*/

(() => {
  if (window.ksCajonListo) return;
  window.ksCajonListo = true;

  const cajon = () => document.querySelector('cart-drawer[data-ks-cajon]');
  const raizDe = (el) => el?.closest?.('[data-ks-carrito]');
  const paginas = () => [...document.querySelectorAll('[data-ks-pagina]')];
  /* Estado del cajón (sugerencias) y estado visible para el respaldo (cajón o página) */
  const estadoCajon = () => cajon()?.querySelector('[data-ks-estado]');
  const estado = () => estadoCajon() || document.querySelector('[data-ks-pagina] [data-ks-estado]');
  /* Secciones que se redibujan en cada cambio: las que hay en esta página */
  const secciones = () => [...(cajon() ? ['cart-drawer'] : []), 'cart-icon-bubble', ...paginas().map((p) => p.dataset.ksSeccion)].join(',');
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  const esperar = (ms) => new Promise((r) => setTimeout(r, ms));
  /* Precio con la moneda que eligió la clienta (la del mercado activo de Shopify) */
  const dinero = (c) => {
    const codigo = window.Shopify?.currency?.active || 'MXN';
    const lang = document.documentElement.lang || 'es';
    const idioma = lang.includes('-') ? lang : `${lang}-${window.Shopify?.country || 'MX'}`;
    let numero;
    try {
      numero = new Intl.NumberFormat(idioma, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(c / 100);
    } catch (e) {
      numero = (c / 100).toFixed(2);
    }
    return `$ ${numero} ${codigo}`;
  };

  const escapar = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const ICONO_MAS = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M10 4.5v11M4.5 10h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const ICONO_OK = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="m4.5 10.5 3.5 3.5 7.5-8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- Avisos para lectores de pantalla ---------- */

  const anunciar = (texto, raiz) => {
    const zona = (raiz || cajon() || paginas()[0])?.querySelector('[data-ks-anuncio]');
    if (!zona || !texto) return;
    zona.textContent = '';
    setTimeout(() => {
      zona.textContent = texto;
    }, 60);
  };

  /* ---------- Barras ---------- */

  const avances = {};

  const pintarBarras = (desdeCero, ambito = document) => {
    ambito
      ?.querySelectorAll('[data-ks-carrito] [data-ks-avance]')
      .forEach((relleno) => {
        const raiz = raizDe(relleno);
        const tipo = relleno.dataset.ksBarra || (relleno.classList.contains('ks-meta__relleno--guardado') ? 'guardado' : 'pedido');
        const clave = `${raiz?.id || 'cajon'}:${tipo}`;
        const destino = `${relleno.dataset.ksAvance}%`;
        const inicio = desdeCero ? '0%' : avances[clave] ?? destino;
        avances[clave] = destino;
        if (reducido.matches) {
          relleno.style.setProperty('--kc-avance', destino);
          return;
        }
        relleno.style.transition = 'none';
        relleno.style.setProperty('--kc-avance', inicio);
        relleno.getBoundingClientRect();
        relleno.style.transition = '';
        setTimeout(() => relleno.style.setProperty('--kc-avance', destino), 20);
      });
  };

  /* ---------- Desvanecido al final de la lista ---------- */

  const revisarDesvanecido = () => {
    const c = cajon();
    const cuerpo = c?.querySelector('[data-ks-cuerpo]');
    const velo = c?.querySelector('[data-ks-desvanecido]');
    if (!cuerpo || !velo) return;
    const alFinal = cuerpo.scrollTop + cuerpo.clientHeight >= cuerpo.scrollHeight - 2;
    velo.classList.toggle('is-oculto', alFinal);
  };

  document.addEventListener(
    'scroll',
    (ev) => {
      if (!(ev.target instanceof Element)) return;
      if (ev.target.matches('[data-ks-cuerpo]')) revisarDesvanecido();
      if (ev.target.matches('[data-ks-sug-carrusel]')) revisarFlechas();
    },
    true
  );

  /* Flechas del carrusel de sugerencias dentro del cajón: se ocultan en cada orilla */
  const revisarFlechas = () => {
    const lista = cajon()?.querySelector('[data-ks-sug-carrusel]');
    if (!lista) return;
    const marco = lista.closest('.ks-sug-carrusel__marco');
    const max = lista.scrollWidth - lista.clientWidth - 2;
    marco.querySelector('[data-ks-sug-mover="-1"]').hidden = lista.scrollLeft <= 2;
    marco.querySelector('[data-ks-sug-mover="1"]').hidden = lista.scrollLeft >= max;
  };

  /* ---------- Sugerencias ---------- */

  /* Caché de la sesión (30 min) para no volver a pedir sugerencias en cada página */
  const CACHE_MIN = 30;
  const leerCache = (clave) => {
    try {
      const v = JSON.parse(sessionStorage.getItem(clave) || 'null');
      return v && Date.now() - v.t < CACHE_MIN * 60000 ? v.d : null;
    } catch (e) {
      return null;
    }
  };
  const guardarCache = (clave, d) => {
    try {
      sessionStorage.setItem(clave, JSON.stringify({ t: Date.now(), d }));
    } catch (e) {
      /* sin almacenamiento, se vuelve a pedir */
    }
  };

  let fuentesFijas = leerCache('ksCajonFijas');
  const complementarias = {};
  let bloqueoPanelHasta = 0;

  const conAncho = (src, ancho) => {
    if (!src) return '';
    return `${src}${src.includes('?') ? '&' : '?'}width=${ancho}`;
  };

  const normalizar = (p) => {
    if (!p || p.available === false) return null;
    const variantes = p.variants || [];
    const v = variantes.find((x) => x.available) || null;
    if (!v) return null;
    const imagen = p.featured_image || p.image || (p.images && p.images[0]);
    const src = typeof imagen === 'string' ? imagen : imagen?.src || imagen?.url || '';
    const precio = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
    return {
      id: String(p.id),
      vid: v.id,
      titulo: p.title,
      handle: p.handle || (p.url || '').split('/products/')[1]?.split('?')[0] || '',
      url: p.url || `/products/${p.handle}`,
      precio,
      img: src,
      detalle: '',
      unica: variantes.length <= 1,
    };
  };

  const cargarFijas = async (c) => {
    if (fuentesFijas) return fuentesFijas;
    const handles = (c.dataset.comprados || '').split(',').map((h) => h.trim()).filter(Boolean);
    const comprados = await Promise.all(
      handles.map((h) =>
        fetch(`/products/${h}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );
    let respaldo = [];
    if (c.dataset.coleccion) {
      respaldo = await fetch(`${c.dataset.coleccion}/products.json?limit=24`)
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => d.products || [])
        .catch(() => []);
    }
    fuentesFijas = [...comprados, ...respaldo].map(normalizar).filter(Boolean);
    guardarCache('ksCajonFijas', fuentesFijas);
    return fuentesFijas;
  };

  const cargarComplementarias = async (c, id) => {
    if (!id) return [];
    if (complementarias[id]) return complementarias[id];
    const guardadas = leerCache(`ksCajonComp${id}`);
    if (guardadas) {
      complementarias[id] = guardadas;
      return guardadas;
    }
    const url = `${c.dataset.recomendaciones}.json?product_id=${id}&limit=10&intent=complementary`;
    complementarias[id] = await fetch(url)
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((d) => (d.products || []).map(normalizar).filter(Boolean))
      .catch(() => []);
    guardarCache(`ksCajonComp${id}`, complementarias[id]);
    return complementarias[id];
  };

  /* Subtítulo del producto (metacampo descriptors.subtitle), p. ej. si es pieza o bolsa */
  const subtitulos = {};
  const subtitulosGuardados = leerCache('ksCajonSub') || {};
  const conSubtitulo = (p) => {
    if (!p.handle) return Promise.resolve(p);
    if (p.handle in subtitulosGuardados) return Promise.resolve({ ...p, detalle: subtitulosGuardados[p.handle] });
    if (!(p.handle in subtitulos)) {
      subtitulos[p.handle] = fetch(`/products/${p.handle}?section_id=karati-producto-dato`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const dato = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ks-dato]');
          return dato ? JSON.parse(dato.textContent).subtitulo || '' : '';
        })
        .catch(() => '');
    }
    return subtitulos[p.handle].then((s) => {
      subtitulosGuardados[p.handle] = s;
      guardarCache('ksCajonSub', subtitulosGuardados);
      return { ...p, detalle: s };
    });
  };

  const elegir = async () => {
    const c = cajon();
    const e = estadoCajon();
    if (!c || !e) return [];
    const enCarrito = new Set((e.dataset.ids || '').split(',').filter(Boolean));
    const [comp, fijas] = await Promise.all([cargarComplementarias(c, e.dataset.ultimo), cargarFijas(c)]);
    const vistos = new Set();
    const nombres = new Set();
    const elegidos = [];
    for (const p of [...comp, ...fijas]) {
      if (elegidos.length >= 7) break;
      if (enCarrito.has(p.id) || vistos.has(p.id) || nombres.has(p.titulo)) continue;
      vistos.add(p.id);
      nombres.add(p.titulo);
      elegidos.push(p);
    }
    return Promise.all(elegidos.map(conSubtitulo));
  };

  const filaPanel = (p) => `
    <li class="ks-sug__item">
      <a class="ks-sug__foto" href="${escapar(p.url)}" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${escapar(conAncho(p.img, 200))}" alt="" width="96" height="96" loading="lazy">` : ''}</a>
      <div class="ks-sug__texto">
        <a class="ks-sug__nombre" href="${escapar(p.url)}">${escapar(p.titulo)}</a>
        ${p.detalle ? `<span class="ks-sug__detalle">${escapar(p.detalle)}</span>` : ''}
        <span class="ks-sug__precio">${dinero(p.precio)}</span>
      </div>
      <button type="button" class="ks-sug__mas" data-ks-sug-agregar="${p.vid}" data-titulo="${escapar(p.titulo)}" aria-label="Agregar ${escapar(p.titulo)}">${ICONO_MAS}</button>
    </li>`;

  const tarjetaMovil = (p, texto) => `
    <li class="ks-sug-tarjeta">
      <a class="ks-sug__foto" href="${escapar(p.url)}" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${escapar(conAncho(p.img, 300))}" alt="" width="140" height="140" loading="lazy">` : ''}</a>
      <a class="ks-sug__nombre" href="${escapar(p.url)}">${escapar(p.titulo)}</a>
      <span class="ks-sug__precio">${dinero(p.precio)}</span>
      <button type="button" class="ks-sug-tarjeta__agregar" data-ks-sug-agregar="${p.vid}" data-titulo="${escapar(p.titulo)}" aria-label="Agregar ${escapar(p.titulo)}">${escapar(texto)}</button>
    </li>`;

  const pintarSugerencias = async () => {
    const c = cajon();
    /* Con el ajuste apagado no se piden recomendaciones */
    if (!c || c.dataset.sugerencias !== 'true') return;
    const lista = await elegir();
    const panel = c.querySelector('[data-ks-panel]');
    const movil = c.querySelector('[data-ks-sug-movil]');
    if (panel && Date.now() >= bloqueoPanelHasta) {
      panel.querySelector('[data-ks-sug-lista]').innerHTML = lista.map(filaPanel).join('');
      panel.hidden = lista.length === 0;
    }
    if (movil) {
      movil.querySelector('[data-ks-sug-carrusel]').innerHTML = lista.map((p) => tarjetaMovil(p, c.dataset.textoAgregar || 'Agregar')).join('');
      movil.hidden = lista.length === 0;
      requestAnimationFrame(revisarFlechas);
    }
    revisarDesvanecido();
  };

  /* ---------- Respaldo del carrito en el dispositivo (48 h) ----------
     Shopify ya guarda el carrito en una cookie; esto lo recupera si se perdió
     (luz, navegador cerrado a la fuerza, cookie borrada). No se recupera si la
     clienta fue a pagar, para no volver a llenar un carrito ya comprado. */
  const RESPALDO = 'ksCarritoRespaldo';
  const HORAS = 48;

  const guardarRespaldo = () => {
    const e = estado();
    if (!e) return;
    try {
      localStorage.setItem(RESPALDO, JSON.stringify({ t: Date.now(), items: e.dataset.respaldo || '', nota: e.dataset.nota || '', pago: 0 }));
    } catch (err) {
      /* sin almacenamiento */
    }
  };

  const marcarPago = () => {
    try {
      const r = JSON.parse(localStorage.getItem(RESPALDO) || 'null');
      if (r) localStorage.setItem(RESPALDO, JSON.stringify({ ...r, pago: Date.now() }));
    } catch (err) {
      /* sin almacenamiento */
    }
  };

  document.addEventListener('submit', (ev) => {
    if (ev.target.querySelector?.('[name="checkout"]') || ev.submitter?.name === 'checkout') marcarPago();
  });
  document.addEventListener('click', (ev) => {
    if (ev.target.closest?.('a[href*="/checkout"], [name="checkout"]')) marcarPago();
  });

  const recuperar = async () => {
    const e = estado();
    if (!e || Number(e.dataset.cantidad) > 0) return false;
    let r = null;
    try {
      r = JSON.parse(localStorage.getItem(RESPALDO) || 'null');
    } catch (err) {
      return false;
    }
    if (!r || !r.items || r.pago || Date.now() - r.t > HORAS * 3600000) {
      if (r && (r.pago || Date.now() - r.t > HORAS * 3600000)) localStorage.removeItem(RESPALDO);
      return false;
    }
    const items = r.items.split(',').map((x) => x.split(':')).map(([id, q]) => ({ id: Number(id), quantity: Number(q) })).filter((x) => x.id && x.quantity);
    if (!items.length) return false;
    try {
      const respuesta = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: secciones(), sections_url: window.location.pathname }),
      });
      const datos = await respuesta.json();
      if (!respuesta.ok || datos.status) return false;
      if (r.nota) {
        fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: r.nota }),
        }).catch(() => {});
      }
      reemplazar(datos.sections);
      return true;
    } catch (err) {
      return false;
    }
  };

  /* ---------- Después de cada dibujo del cajón ---------- */

  /* "Seguir comprando" de la página: a la última colección visitada o al inicio */
  const ULTIMA = 'ksUltimaColeccion';
  try {
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(window.location.pathname)) {
      localStorage.setItem(ULTIMA, window.location.pathname + window.location.search);
    }
  } catch (e) {
    /* sin almacenamiento */
  }
  const apuntarSeguir = () => {
    let url = null;
    try {
      url = localStorage.getItem(ULTIMA);
    } catch (e) {
      url = null;
    }
    if (url) document.querySelectorAll('[data-ks-seguir]').forEach((a) => (a.href = url));
  };

  const despuesDeDibujar = () => {
    pintarBarras(false);
    apuntarSeguir();
    revisarDesvanecido();
    guardarRespaldo();
    /* Las sugerencias solo se piden con el cajón abierto */
    if (cajon()?.classList.contains('active')) pintarSugerencias();
  };

  /* Los botones de pago rápido de Shopify se dejan vivos entre dibujos: se mueven al HTML nuevo */
  const conservar = (actual, nuevo) => {
    nuevo.querySelectorAll('[data-ks-conservar]').forEach((lugar) => {
      const vivo = actual.querySelector(`[data-ks-conservar="${lugar.dataset.ksConservar}"]`);
      if (vivo && vivo.childElementCount) lugar.replaceWith(vivo);
    });
  };

  const reemplazar = (datos) => {
    const c = cajon();
    const html = datos?.['cart-drawer'];
    const actual = document.getElementById('CartDrawer');
    if (html && actual) {
      const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      if (nuevo) {
        const scroll = actual.querySelector('[data-ks-cuerpo]')?.scrollTop || 0;
        conservar(actual, nuevo);
        actual.replaceChildren(...nuevo.childNodes);
        const cuerpo = actual.querySelector('[data-ks-cuerpo]');
        if (cuerpo) cuerpo.scrollTop = scroll;
        actual.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => c.close());
      }
    }
    paginas().forEach((p) => {
      const htmlPagina = datos?.[p.dataset.ksSeccion];
      const actualPagina = p.querySelector('[data-ks-redibujar]');
      if (!htmlPagina || !actualPagina) return;
      const nuevo = new DOMParser().parseFromString(htmlPagina, 'text/html').querySelector('[data-ks-redibujar]');
      if (!nuevo) return;
      conservar(actualPagina, nuevo);
      actualPagina.replaceChildren(...nuevo.childNodes);
      p.classList.toggle('is-vacio', Number(p.querySelector('[data-ks-estado]')?.dataset.cantidad || 0) === 0);
    });
    const burbuja = datos?.['cart-icon-bubble'];
    const icono = document.getElementById('cart-icon-bubble');
    if (burbuja && icono) {
      const seccion = new DOMParser().parseFromString(burbuja, 'text/html').querySelector('.shopify-section');
      if (seccion) icono.innerHTML = seccion.innerHTML;
    }
    c?.classList.toggle('is-empty', Number(estadoCajon()?.dataset.cantidad || 0) === 0);
    despuesDeDibujar();
  };

  /* ---------- Integración con el cajón del tema ---------- */

  const resaltar = (varianteId) => {
    if (!varianteId) return;
    const fila = cajon()?.querySelector(`[data-variante="${varianteId}"]`);
    if (!fila || reducido.matches) return;
    fila.classList.remove('is-recien');
    fila.getBoundingClientRect();
    fila.classList.add('is-recien');
  };

  const preparar = (c) => {
    if (c.ksPreparado) return;
    c.ksPreparado = true;

    /* Al agregar desde cualquier parte, el tema redibuja y abre: aquí se suman el resaltado y el aviso */
    const original = c.renderContents.bind(c);
    c.renderContents = (respuesta) => {
      original(respuesta);
      const item = respuesta?.items?.[0] || respuesta;
      setTimeout(() => {
        despuesDeDibujar();
        resaltar(item?.variant_id || item?.id);
        const titulo = item?.product_title || item?.title;
        if (titulo) anunciar((c.dataset.textoAgregado || '').replace('[PRODUCTO]', titulo));
      }, 30);
    };

    /* Al abrir: barras desde 0 cuando el cajón terminó de entrar, foco en cerrar y trampa de foco en cajón + panel */
    new MutationObserver(() => {
      const abierto = c.classList.contains('active');
      if (abierto && !c.ksAbierto) {
        c.ksAbierto = true;
        pintarSugerencias();
        setTimeout(
          () => {
            pintarBarras(true, c);
            revisarDesvanecido();
            const cerrar = c.querySelector('.ks-cajon__cerrar');
            const dialogo = c.querySelector('.ks-cajon__dialogo');
            if (typeof window.trapFocus === 'function' && dialogo) window.trapFocus(dialogo, cerrar);
            else cerrar?.focus();
          },
          reducido.matches ? 150 : 340
        );
      } else if (!abierto) {
        c.ksAbierto = false;
      }
    }).observe(c, { attributes: true, attributeFilter: ['class'] });
  };

  /* ---------- Cantidad, quitar, nota y sugerencias ---------- */

  /* Cada cambio lleva un turno; solo la respuesta del último turno pinta el cajón,
     así varios clics seguidos nunca dejan un estado viejo encima de uno nuevo */
  let turnoCambio = 0;
  const esperasCambio = new WeakMap();

  const refrescar = async () => {
    try {
      const datos = await fetch(`${window.routes?.root_url || '/'}?sections=${secciones()}`).then((r) => r.json());
      reemplazar(datos);
    } catch (e) {
      /* sin red: se queda lo que hay */
    }
  };

  const cambiar = async (fila, nueva) => {
    const raiz = raizDe(fila);
    const num = fila.querySelector('[data-ks-num]');
    const aviso = fila.querySelector('[data-ks-aviso]');
    const turno = ++turnoCambio;
    num.value = nueva || num.value;
    fila.classList.add('is-cargando');
    if (aviso) aviso.hidden = true;
    if (nueva === 0) {
      fila.style.maxHeight = `${fila.offsetHeight}px`;
      requestAnimationFrame(() => fila.classList.add('is-saliendo'));
    }
    try {
      const cuerpo = {
        quantity: nueva,
        sections: secciones(),
        sections_url: window.location.pathname,
      };
      /* La clave identifica la línea aunque otra se haya borrado antes */
      if (fila.dataset.key) cuerpo.id = fila.dataset.key;
      else cuerpo.line = Number(fila.dataset.ksLinea);
      const respuesta = await fetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo),
      });
      const datos = await respuesta.json();
      if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || '');
      if (turno !== turnoCambio) return;
      if (nueva === 0) await esperar(200);
      reemplazar(datos.sections);
      if (nueva === 0) anunciar((raiz?.dataset.textoQuitado || '').replace('[PRODUCTO]', fila.dataset.titulo || ''), raiz);
    } catch (error) {
      if (turno !== turnoCambio) return;
      /* Se vuelve a pedir el carrito al servidor para que lo visible sea lo real */
      await refrescar();
      const filaNueva = fila.dataset.key ? raiz?.querySelector(`[data-key="${CSS.escape(fila.dataset.key)}"]`) : null;
      const avisoNuevo = filaNueva?.querySelector('[data-ks-aviso]');
      if (avisoNuevo && error.message) {
        avisoNuevo.textContent = error.message;
        avisoNuevo.hidden = false;
      }
    }
  };

  /* Los clics seguidos en − y + se juntan: el número cambia al momento y se envía al dejar de pulsar */
  const programarCambio = (fila, nueva) => {
    const num = fila.querySelector('[data-ks-num]');
    const max = Number(num.max) || Infinity;
    const destino = Math.max(0, Math.min(nueva, max));
    num.value = destino;
    clearTimeout(esperasCambio.get(fila));
    if (destino === 0) {
      cambiar(fila, 0);
      return;
    }
    esperasCambio.set(fila, setTimeout(() => cambiar(fila, destino), 280));
  };

  const agregarSugerencia = async (boton) => {
    const c = cajon();
    boton.disabled = true;
    try {
      const respuesta = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(boton.dataset.ksSugAgregar), quantity: 1 }],
          sections: secciones(),
          sections_url: window.location.pathname,
        }),
      });
      const datos = await respuesta.json();
      if (!respuesta.ok || datos.status) throw new Error();
      /* Palomita durante 1.2 s; después la sugerencia se cambia por la siguiente */
      const enPanel = boton.classList.contains('ks-sug__mas');
      if (enPanel) {
        boton.classList.add('is-hecho');
        boton.innerHTML = ICONO_OK;
        bloqueoPanelHasta = Date.now() + 1200;
        setTimeout(() => {
          bloqueoPanelHasta = 0;
          pintarSugerencias();
        }, 1250);
      }
      c.renderContents(datos);
    } catch (e) {
      boton.disabled = false;
    }
  };

  const vaciar = async (raiz) => {
    const modal = raiz.querySelector('[data-ks-vaciar-modal]');
    const si = modal?.querySelector('[data-ks-vaciar-si]');
    if (si) si.disabled = true;
    try {
      await fetch(`${window.routes?.cart_clear_url || '/cart/clear'}.js`, { method: 'POST', headers: { Accept: 'application/json' } });
    } catch (e) {
      /* se refresca igual para mostrar lo real */
    }
    await refrescar();
    if (si) si.disabled = false;
    modal?.close();
  };

  document.addEventListener('click', (ev) => {
    const c = raizDe(ev.target);
    if (!c) return;

    if (ev.target.closest('[data-ks-vaciar]')) {
      c.querySelector('[data-ks-vaciar-modal]')?.showModal();
      return;
    }
    const modal = ev.target.closest('[data-ks-vaciar-modal]');
    if (modal) {
      /* Clic en el fondo o en Cancelar cierra; Sí vacía */
      if (ev.target === modal || ev.target.closest('[data-ks-vaciar-no]')) modal.close();
      else if (ev.target.closest('[data-ks-vaciar-si]')) vaciar(c);
      return;
    }

    const botonCambiar = ev.target.closest('[data-ks-cambiar]');
    const botonQuitar = ev.target.closest('[data-ks-quitar]');
    const botonUno = ev.target.closest('[data-ks-uno]');
    if (botonCambiar || botonQuitar || botonUno) {
      const fila = ev.target.closest('[data-ks-linea]');
      if (!fila || fila.classList.contains('is-saliendo')) return;
      const actual = Number(fila.querySelector('[data-ks-num]').value);
      let nueva = 1;
      if (botonQuitar) nueva = 0;
      else if (botonCambiar) nueva = Math.max(0, actual + Number(botonCambiar.dataset.ksCambiar));
      programarCambio(fila, nueva);
      return;
    }

    const botonNota = ev.target.closest('[data-ks-nota-boton]');
    if (botonNota) {
      const campo = c.querySelector('[data-ks-nota]');
      const abrir = campo.hidden;
      campo.hidden = !abrir;
      botonNota.setAttribute('aria-expanded', String(abrir));
      if (abrir) campo.focus();
      return;
    }

    const mover = ev.target.closest('[data-ks-sug-mover]');
    if (mover) {
      const lista = c.querySelector('[data-ks-sug-carrusel]');
      const paso = (lista.querySelector('.ks-sug-tarjeta')?.getBoundingClientRect().width || 140) + 12;
      lista.scrollBy({ left: Number(mover.dataset.ksSugMover) * paso, behavior: reducido.matches ? 'auto' : 'smooth' });
      return;
    }

    const pestana = ev.target.closest('[data-ks-pestana]');
    if (pestana) {
      const plegado = c.classList.toggle('ks-cajon--plegado');
      pestana.setAttribute('aria-expanded', String(!plegado));
      return;
    }

    const botonSug = ev.target.closest('[data-ks-sug-agregar]');
    if (botonSug && !botonSug.disabled) agregarSugerencia(botonSug);
  });

  /* Cantidad escrita a mano: se aplica al salir del campo o con Enter, dentro del máximo disponible */
  document.addEventListener('change', (ev) => {
    if (!(ev.target instanceof Element) || !ev.target.matches('[data-ks-carrito] [data-ks-num]')) return;
    const campo = ev.target;
    const fila = campo.closest('[data-ks-linea]');
    let nueva = Math.floor(Number(campo.value));
    const max = Number(campo.max) || Infinity;
    if (!Number.isFinite(nueva) || nueva < 1) nueva = 1;
    if (nueva > max) nueva = max;
    if (String(nueva) === campo.dataset.anterior) {
      campo.value = nueva;
      return;
    }
    programarCambio(fila, nueva);
  });

  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Enter' && ev.target instanceof Element && ev.target.matches('[data-ks-carrito] [data-ks-num]')) {
      ev.preventDefault();
      ev.target.blur();
    }
  });

  /* La nota se guarda al salir del campo */
  document.addEventListener('focusout', (ev) => {
    if (!(ev.target instanceof Element) || !ev.target.matches('[data-ks-carrito] [data-ks-nota]')) return;
    fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: ev.target.value }),
    }).catch(() => {});
  });

  /* ---------- Factura y CSF ----------
     "Requiere factura" (Sí/No) va en los atributos del carrito. La CSF se sube a
     Shopify agregando un momento 1 pieza de un artículo del carrito con el
     archivo como propiedad oculta; se guarda el enlace en el atributo "CSF" y
     esa pieza se quita en seguida, así el carrito queda igual. */

  const CSF_MAX = 10 * 1024 * 1024;
  const CSF_TIPOS = ['application/pdf', 'image/jpeg', 'image/png'];

  const actualizarAtributos = async (atributos) => {
    const respuesta = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: atributos, sections: secciones(), sections_url: window.location.pathname }),
    });
    const datos = await respuesta.json();
    if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || '');
    return datos;
  };

  const subirCsf = async (archivo) => {
    const carrito = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
    const variantes = [...new Set(carrito.items.map((i) => i.variant_id))];
    for (const id of variantes) {
      const datos = new FormData();
      datos.append('id', id);
      datos.append('quantity', '1');
      datos.append('properties[_CSF]', archivo, archivo.name);
      const respuesta = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: datos,
      });
      const linea = await respuesta.json();
      if (!respuesta.ok || linea.status) continue;
      const url = linea.properties?._CSF;
      await fetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: linea.key, quantity: 0 }),
      });
      if (url) return url;
    }
    throw new Error('');
  };

  const errorCsf = (caja, texto) => {
    const error = caja.querySelector('[data-ks-csf-error]');
    if (!error) return;
    error.textContent = texto;
    error.hidden = !texto;
  };

  document.addEventListener('change', async (ev) => {
    if (!(ev.target instanceof Element)) return;
    const caja = ev.target.closest('[data-ks-carrito] [data-ks-factura]');
    if (!caja) return;

    if (ev.target.matches('[data-ks-factura-op]')) {
      const requiere = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value === 'Sí';
      caja.dataset.requiere = String(requiere);
      caja.querySelector('[data-ks-csf]').hidden = !requiere;
      errorCsf(caja, '');
      /* Con No se limpian también la constancia y su nombre */
      const atributos = requiere ? { 'Requiere factura': 'Sí' } : { 'Requiere factura': 'No', CSF: '', 'CSF archivo': '' };
      if (!requiere) {
        caja.dataset.csf = '';
        caja.querySelector('.ks-factura__lista')?.remove();
      }
      actualizarAtributos(atributos).catch(() => {});
      return;
    }

    if (ev.target.matches('[data-ks-csf-archivo]')) {
      const archivo = ev.target.files?.[0];
      if (!archivo) return;
      if (!CSF_TIPOS.includes(archivo.type) || archivo.size > CSF_MAX) {
        errorCsf(caja, caja.dataset.textoTipo);
        ev.target.value = '';
        return;
      }
      const texto = caja.querySelector('[data-ks-csf-texto]');
      errorCsf(caja, '');
      caja.classList.add('is-subiendo');
      if (texto) texto.textContent = caja.dataset.textoSubiendo;
      try {
        const url = await subirCsf(archivo);
        const datos = await actualizarAtributos({ 'Requiere factura': 'Sí', CSF: url, 'CSF archivo': archivo.name });
        reemplazar(datos.sections);
        anunciar(archivo.name, raizDe(caja));
      } catch (err) {
        caja.classList.remove('is-subiendo');
        if (texto) texto.textContent = archivo.name;
        errorCsf(caja, caja.dataset.textoTipo);
      }
    }
  });

  /* Con factura y sin CSF no se pasa a pagar */
  document.addEventListener(
    'submit',
    (ev) => {
      if (!(ev.target instanceof Element) || !ev.target.matches('[data-ks-pagar-form]')) return;
      const caja = raizDe(ev.target)?.querySelector('[data-ks-factura]');
      if (!caja || caja.dataset.requiere !== 'true' || caja.dataset.csf === '1') return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      errorCsf(caja, caja.dataset.textoFalta);
      caja.querySelector('[data-ks-csf-archivo]')?.focus();
      caja.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    },
    true
  );

  const iniciar = () => {
    const c = cajon();
    if (c && typeof c.renderContents !== 'function') {
      setTimeout(iniciar, 200);
      return;
    }
    if (!c && !paginas().length) return;
    if (c) preparar(c);
    if (c) pintarBarras(false, c);
    paginas().forEach((p) => pintarBarras(true, p));
    apuntarSeguir();
    /* Después de que cargó la página, sin competir con ella */
    const luego = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
    luego(async () => {
      const recuperado = await recuperar();
      if (!recuperado) guardarRespaldo();
    });
  };

  iniciar();
})();
